import { BannerConfig } from "@nova/constants"
import { createSelector, createSlice } from "@reduxjs/toolkit"
import { RootState } from "integrations/redux"

interface BannerIgnoredState {
    ignored: BannerConfig[]
}

const {
    reducer,
    actions: { ignoreBanner },
} = createSlice({
    name: "ignored-banners",
    initialState: { ignored: [] } as BannerIgnoredState,
    reducers: {
        ignoreBanner: (state, action: { payload: BannerConfig }) => {
            state.ignored = [...state.ignored, action.payload]
        },
    },
})

const root = (state: RootState) => state.ignoredBanners

export const selectIgnoredBanners = createSelector([root], (state) => state.ignored)

export default reducer

export { ignoreBanner }
